import React, { memo, useState } from "react";
import { Button, Input, Space } from "antd";
import { useTranslation } from "react-i18next";

import { mealsPlanActions, RequestStatus } from "@fitness-app/app-store";

import { useAppDispatch, useAppSelector } from "~/store/initializeStore";

export const MealsSearch = memo((): React.ReactElement => {
  const { t } = useTranslation("nutrition");
  const [searchValue, setSearchValue] = useState("");
  const dispatch = useAppDispatch();
  const searchTerm = useAppSelector((store) => store.mealsPlans.searchTerm);
  const listStatus = useAppSelector((store) => store.mealsPlans.listStatus);
  const isSearchMode = Boolean(searchTerm);

  const onClear = () => {
    setSearchValue("");
    dispatch(mealsPlanActions.setSearchTerm(""));
    void dispatch(mealsPlanActions.fetchMealsPlan());
  };

  const onSearch = (value: string) => {
    const trimmed = value.trim();
    if (!trimmed) {
      if (isSearchMode) {
        onClear();
      }
      return;
    }

    dispatch(mealsPlanActions.setSearchTerm(trimmed));
    void dispatch(mealsPlanActions.fetchMealsPlan());
  };

  return (
    <Space size={6}>
      <Input.Search
        placeholder={t<string>("common:button.search")}
        onSearch={onSearch}
        value={searchValue}
        onChange={(e) => setSearchValue(e.target.value)}
        className="my-5 w-full md:w-[300px]"
        loading={listStatus === RequestStatus.FETCHING}
      />
      {Boolean(searchTerm) && (
        <Button onClick={onClear} type="link">
          {t("products:search.reset")}
        </Button>
      )}
    </Space>
  );
});

MealsSearch.displayName = "MealsSearch";
